import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCG = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m13.552 47.232 18.366-15.313L47.23 13.553A25.11 25.11 0 0 0 36.462 2.778l-18.38 15.306-15.305 18.38a25.108 25.108 0 0 0 10.775 10.768Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M42.678 42.678c7.887-7.887 9.401-19.733 4.546-29.141L13.537 47.223c9.408 4.856 21.254 3.342 29.141-4.545Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M7.322 7.322c-7.888 7.887-9.402 19.732-4.546 29.14L36.463 2.777C27.054-2.08 15.209-.566 7.322 7.322Z"
}));
FlagCG.displayName = 'FlagCG';
export default withFlagWrapper(FlagCG);
//# sourceMappingURL=index.js.map